const FIELD_PATTERN = /^Field "(\w+)" error: (.+)$/;

/**
 * The registration API answers errors in THREE different shapes depending on
 * how the failure was raised, not just its status code:
 *  - 422/400 (validation, via the legacy response adapter): `error` is an
 *    array of `Field "x" error: ...` strings, one per invalid field.
 *  - 409 (duplicate email): same adapter, but a single plain-text `error`
 *    entry with no "Field X error:" prefix — it's still unambiguously about
 *    the email address.
 *  - 429 (rate limited): bypasses the adapter entirely — a flat
 *    `{status: 'error', message: '<string>'}` with no `error` array at all.
 *
 * Mapping errors to the field that caused them lets the form show them
 * inline next to that input instead of a single undifferentiated banner.
 */
export function parseRegistrationError(err) {
	const status = err?.response?.status;
	const body = err?.response?.data;

	if (status === 429) {
		return { fieldErrors: {}, generalMessage: body?.message || 'Too many attempts. Please try again later.' };
	}

	const errors = Array.isArray(body?.error) ? body.error : [];
	if (errors.length === 0) {
		return { fieldErrors: {}, generalMessage: 'Something went wrong. Please try again.' };
	}

	const fieldErrors = {};
	const generalMessages = [];

	errors.forEach(msg => {
		const match = FIELD_PATTERN.exec(msg);
		if (match) {
			fieldErrors[match[1]] = match[2];
		} else if (status === 409) {
			fieldErrors.email = msg;
		} else {
			generalMessages.push(msg);
		}
	});

	return { fieldErrors, generalMessage: generalMessages.join(' ') || null };
}
